webpackJsonp([174448160903362],{

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2nd-street-abstract.2b169975.png";

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cheers-abstract.e7d82de0.png";

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/riverrock-2024.9fcd2f15.jpeg";

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vr-live-downtown.b9d55c82.jpg";

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vr-work-downtown.28876f76.jpg";

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.previewQuery = exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Meta = __webpack_require__(6);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	var _Banners = __webpack_require__(11);
	
	var _PageHelpers = __webpack_require__(25);
	
	var _cheersAbstract = __webpack_require__(348);
	
	var _cheersAbstract2 = _interopRequireDefault(_cheersAbstract);
	
	var _ndStreetAbstract = __webpack_require__(347);
	
	var _ndStreetAbstract2 = _interopRequireDefault(_ndStreetAbstract);
	
	var _riverrock = __webpack_require__(349);
	
	var _riverrock2 = _interopRequireDefault(_riverrock);
	
	var _vrLiveDowntown = __webpack_require__(351);
	
	var _vrLiveDowntown2 = _interopRequireDefault(_vrLiveDowntown);
	
	var _vrWorkDowntown = __webpack_require__(352);
	
	var _vrWorkDowntown2 = _interopRequireDefault(_vrWorkDowntown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListGrid = function ListGrid(_ref) {
	  var data = _ref.data;
	
	  var page = data.mortyPage;
	  var gridData = void 0;
	
	  // Filter out Featured Events page
	  var allPages = void 0;
	  if (data.allMortyPage != null) {
	    allPages = data.allMortyPage.edges.filter(function (p) {
	      return p.node.title != 'Featured Events';
	    });
	  }
	
	  // If there are events, add them to the data
	  if (data.allMortyEvent != null) {
	    gridData = allPages.concat(data.allMortyEvent.edges);
	  } else {
	    gridData = allPages;
	  }
	  // Force ordering
	  var pageRoutes = ['/explore-downtown/riverfront-canal-walk/', '/explore-downtown/restaurants/', '/explore-downtown/shopping/', '/explore-downtown/arts-and-culture/', '/explore-downtown/outdoors/', '/explore-downtown/attractions/', '/explore-downtown/outdoors-attractions/', '/explore-downtown/outdoors-attractions/james-river-park-system/', '/explore-downtown/parking-and-transportation/', '/live-downtown/historic-neighborhoods/', '/live-downtown/virtual-tour/', '/live-downtown/residential-facts/', '/live-downtown/places-to-live/', '/live-downtown/living-essentials/', '/work-downtown/demographics/', '/work-downtown/virtual-tour/', '/work-downtown/development/', '/work-downtown/relocating/', '/our-events/friday-cheers/', '/our-events/2nd-street-festival/', '/our-events/richmond-folk-festival/', '/our-events/camp-kanawha-halloween-cruises/', '/our-events/movies-on-browns-island/', '/our-services/riverfront-canal-cruises/', '/our-services/browns-island-improvement-plan/', '/our-services/downtown-marketing/', '/our-services/clean-safe-green/', '/our-services/browns-island-rentals/', '/about-us/our-board/', '/about-us/our-staff/', '/about-us/our-contributors/', '/about-us/donate/', '/about-us/faq/', '/about-us/reports/', '/about-us/about-venture-richmond/', '/about-us/contact-us/', '/manchester-spotlight/downtown-connections/', '/manchester-spotlight/a-taste-of-manchester/', '/manchester-spotlight/get-outdoors/', '/manchester-spotlight/home-sweet-home/', '/manchester-spotlight/local-legends/', '/manchester-spotlight/tune-in/'];
	
	  var orderedPages = [];
	  if (gridData) {
	    // a ListGrid page with no content blows up because gridData is null
	    pageRoutes.forEach(function (route, index) {
	      var page = gridData.find(function (obj) {
	        return obj.node.route === route;
	      });
	      orderedPages.push(page);
	    });
	  }
	
	  // Filter out undefined values
	  var filteredPages = orderedPages.filter(Boolean);
	
	  // Catch for pages that aren't Our Events
	  // if (page.title != "Our Events") {
	  //   orderedPages = gridData;
	  // }
	
	  // Render blocks
	  var blocks = void 0;
	  if (filteredPages) {
	    blocks = filteredPages.map(function (d) {
	      return _react2.default.createElement(_PageHelpers.ListGridItem, { key: d.node.id, page: d.node });
	    });
	  }
	
	  // Render banner
	  var Banner = function Banner(_ref2) {
	    var page = _ref2.page;
	
	    if (page.title != 'Live Downtown' && page.title != 'Explore Downtown' && page.title != 'Work Downtown') {
	      // abstractPhotoForMobile is hacky fix for one specific page while avoiding making database and graphql schema changes
	      return _react2.default.createElement(_Banners.ListGridBannerMinor, { page: page, abstractPhotoForMobile: page.route === '/manchester-spotlight/' });
	    }
	    return _react2.default.createElement(_Banners.ListGridBanner, { page: page });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Meta2.default, { page: page }),
	    _react2.default.createElement(Banner, { page: page }),
	    _react2.default.createElement(
	      'div',
	      { className: 'pv3 pv4-m pv5-l flex items-center justify-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'w-100' },
	        page.slug === 'our-events' ? _react2.default.createElement(
	          'div',
	          { className: 'flex-column' },
	          _react2.default.createElement(
	            'div',
	            { className: 'list-grid-item flex mb1 mb0-m mw-1060 center-m relative' },
	            _react2.default.createElement(
	              'a',
	              { className: 'list-grid-item__info bg-stone dark relative flex flex-column justify-between', href: '/our-events/friday-cheers/' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'p-averta p-lead-averta--m h-2--l' },
	                  'Friday Cheers'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'p--small mt1-l p--m ttu-m h-3--l mbo' },
	                  'Your favorite summer concert series is back to bring you the best music at the best price on Brown\'s Island every Friday in May & June'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex jusitfy-start items-center' },
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'o-40 dark h-6 ttu mb0 tc' },
	                  'Learn More'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'list-grid-item__image bg-blue flex ml0 mt2-m mt3-l', href: '/our-events/friday-cheers/' },
	              _react2.default.createElement('img', { alt: 'Friday Cheers', className: 'w-100 h-100 image-cover mb0', src: _cheersAbstract2.default })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'list-grid-item flex mb1 mb0-m mw-1060 center-m relative' },
	            _react2.default.createElement(
	              'a',
	              { className: 'list-grid-item__info bg-stone dark relative flex flex-column justify-between', href: '/our-events/dominion-energy-riverrock/' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'p-averta p-lead-averta--m h-2--l' },
	                  'Dominion Energy Riverrock'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'p--small mt1-l p--m ttu-m h-3--l mbo' },
	                  'Explore Richmond\'s great outdoors at the nation\'s premier sports and action-packed festival on the East Coast.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex jusitfy-start items-center' },
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'o-40 dark h-6 ttu mb0 tc' },
	                  'Learn More'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'list-grid-item__image bg-blue flex ml0 mt2-m mt3-l', href: '/our-events/dominion-energy-riverrock/' },
	              _react2.default.createElement('img', { alt: 'River Rock', className: 'w-100 h-100 image-cover mb0', src: _riverrock2.default })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'list-grid-item flex mb1 mb0-m mw-1060 center-m relative' },
	            _react2.default.createElement(
	              'a',
	              { className: 'list-grid-item__info bg-stone dark relative flex flex-column justify-between', href: '/our-events/2nd-street-festival/' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'p-averta p-lead-averta--m h-2--l' },
	                  '2nd Street Festival'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'p--small mt1-l p--m ttu-m h-3--l mbo' },
	                  'This community festival is an annual celebration of the Historic Jackson Ward neighborhood in downtown Richmond.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex jusitfy-start items-center' },
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'o-40 dark h-6 ttu mb0 tc' },
	                  'Learn More'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'list-grid-item__image bg-blue flex ml0 mt2-m mt3-l', href: '/our-events/2nd-street-festival/' },
	              _react2.default.createElement('img', { alt: 'Second Street Festival', className: 'w-100 h-100 image-cover mb0', src: _ndStreetAbstract2.default })
	            )
	          )
	        ) : null,
	        page.slug === 'live-downtown' ? _react2.default.createElement(
	          'div',
	          { className: 'flex-column' },
	          _react2.default.createElement(
	            'div',
	            { className: 'list-grid-item flex mb1 mb0-m mw-1060 center-m relative' },
	            _react2.default.createElement(
	              'a',
	              { className: 'list-grid-item__info bg-stone dark relative flex flex-column justify-between', href: '/live-downtown/virtual-tour/' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'p-averta p-lead-averta--m h-2--l' },
	                  'Virtual Tour'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'p--small mt1-l p--m ttu-m h-3--l mbo' },
	                  'A DRONE-BASED MAP THAT ALLOWS YOU TO TOUR DOWNTOWN RICHMOND VIRTUALLY.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex jusitfy-start items-center' },
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'o-40 dark h-6 ttu mb0 tc' },
	                  'Learn More'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'list-grid-item__image bg-blue flex ml0 mt2-m mt3-l', href: '/live-downtown/virtual-tour/' },
	              _react2.default.createElement('img', { alt: 'Virtual tour', className: 'w-100 h-100 image-cover mb0', src: _vrLiveDowntown2.default })
	            )
	          )
	        ) : null,
	        page.slug === 'work-downtown' ? _react2.default.createElement(
	          'div',
	          { className: 'flex-column' },
	          _react2.default.createElement(
	            'div',
	            { className: 'list-grid-item flex mb1 mb0-m mw-1060 center-m relative' },
	            _react2.default.createElement(
	              'a',
	              { className: 'list-grid-item__info bg-stone dark relative flex flex-column justify-between', href: '/work-downtown/virtual-tour/' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'p-averta p-lead-averta--m h-2--l' },
	                  'Virtual Tour'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'p--small mt1-l p--m ttu-m h-3--l mbo' },
	                  'A DRONE-BASED MAP THAT ALLOWS YOU TO TOUR DOWNTOWN RICHMOND VIRTUALLY.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex jusitfy-start items-center' },
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'o-40 dark h-6 ttu mb0 tc' },
	                  'Learn More'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'list-grid-item__image bg-blue flex ml0 mt2-m mt3-l', href: '/work-downtown/virtual-tour/' },
	              _react2.default.createElement('img', { alt: 'Virtual tour', className: 'w-100 h-100 image-cover mb0', src: _vrWorkDowntown2.default })
	            )
	          )
	        ) : null,
	        blocks,
	        page.slug === 'our-events' && data.featuredEventsPage && _react2.default.createElement(_PageHelpers.ListGridItem, { page: data.featuredEventsPage, full: true })
	      )
	    )
	  );
	};
	
	exports.default = ListGrid;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	var previewQuery = exports.previewQuery = '\n  query ListGrid($id: String!, $section: String) {\n    mortyPage(id: { eq: $id }) {\n      title\n      route\n      slug\n      subtitle\n      bannerImageAltText\n      abstractPhotoAltText\n      bannerImageFocalPointX\n      bannerImageFocalPointY\n      bannerImage {\n        url\n      }\n      abstractPhotoFocalPointX\n      abstractPhotoFocalPointY\n      abstractPhoto {\n        url\n      }\n      metaTitle\n      metaDescription\n      metaKeywords\n    }\n    featuredEventsPage: mortyPage(slug: { eq: "featured-events" }) {\n      route\n      title\n      abstract\n      abstractPhotoAltText\n      abstractPhoto {\n        url\n      }\n      abstractPhotoFocalPointX\n      abstractPhotoFocalPointY\n    }\n    allMortyPage(\n      filter: {\n        section: { eq: $section }\n        title: { ne: "Friday Cheers Lineup" }\n      }\n    ) {\n      edges {\n        node {\n          id\n          title\n          section\n          abstract\n          route\n          abstractPhotoAltText\n          abstractPhotoFocalPointX\n          abstractPhotoFocalPointY\n          abstractPhoto {\n            url\n          }\n        }\n      }\n    }\n    allMortyEvent(filter: { section: { eq: $section } }) {\n      edges {\n        node {\n          id\n          title\n          section\n          abstract\n          route\n          abstractPhotoAltText\n          abstractPhotoFocalPointX\n          abstractPhotoFocalPointY\n          abstractPhoto {\n            url\n          }\n        }\n      }\n    }\n  }\n';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-list-grid-js-0fc43629e7352be36859.js